// extracted by mini-css-extract-plugin
module.exports = {"desc":"Disciplines-module__desc___1hnhl"};